module.exports = __webpack_public_path__ + "img/Dai-cb1-mc1.d0bbdd73.png";